const getters = {
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  name: state => state.user.name,
  menus: state => state.user.menus,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js